import { Box, BoxProps, Container, ContainerProps } from "@mui/material"

export const NexPageContainer = (props: ContainerProps & BoxProps) => {
    const { maxWidth, py, ...rest } = props
    return <Container component={Box} py={py ?? 8} maxWidth={maxWidth ?? "xl"} {...rest} />
}
